import TrailSeriesIndexPage from "lx/trailSeriesIndexPage";

export { TrailSeriesIndexPage };

customElements.define(
  "lx-trail-series-index-page",
  TrailSeriesIndexPage.CustomElementConstructor
);
